module.exports = __webpack_public_path__ + "static/media/step-1.c2eadde8.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/loyal-design-system/assets/images/landings/cashBack/step-1.png
// module id = 423
// module chunks = 14